module.exports = __webpack_public_path__ + "media/images/icons/file-image-790739f329a86dcfbdd335215d7e59cc.svg";